import { integrationIdFormat } from "@redotech/redo-integration-id";
import * as z from "zod";

export const deleteConnection = {
  name: "deleteConnection" as const,
  input: z.object({ id: integrationIdFormat.schema }),
  output: z.null(),
};
